import { type FC } from 'react';

import styles from './TrainerSetup.module.css';

interface TrainerSetupProps {
  /** id позиции — для уникального id заголовка */
  id: string;
  steps: readonly string[];
}

/** Блок «Настройка тренажёра» — над упражнениями в карточке позиции */
export const TrainerSetup: FC<TrainerSetupProps> = ({ id, steps }) => {
  const titleId = `setup-${id}`;

  return (
    <section className={styles.root} aria-labelledby={titleId}>
      <h2 className={styles.title} id={titleId}>
        Настройка тренажёра
      </h2>
      <ol className={styles.steps}>
        {steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
    </section>
  );
};
